<div class="sticky-buttons">
    <ul>
        <li>
            <a [href]="'tel:' + window.info_data.telefono1" [title]="window.info_data.telefono1" class="phone-btn"><i class="fas fa-phone"></i></a>
        </li>
    </ul>
</div>